import './index.css'
import * as React from 'react'
import Modal from 'react-modal'
import modalStyles from 'components/utils/modalStyles'
type Props = {
  exclusionList?: Array<string>
  shortlists: Array<Record<string, any>>
  onAddToShortlist: (...args: Array<any>) => any
  onClose: (...args: Array<any>) => any
}
export default class AddToShortlistModal extends React.Component<Props> {
  _renderShortlistOptions(): Array<React.ReactNode> {
    const { exclusionList, shortlists } = this.props
    return shortlists.map((shortlist, index) => {
      if (exclusionList && exclusionList.indexOf(shortlist.id) > -1) return null
      return (
        <button
          key={index}
          className="AddToShortlist_ShortlistBtn"
          onClick={this.props.onAddToShortlist.bind(this, shortlist, index)}
        >
          {shortlist.title ? (
            <span>{shortlist.title}</span>
          ) : (
            <span>Untitled playlist</span>
          )}
        </button>
      )
    })
  }

  render(): React.ReactNode {
    const title = 'Add to Playlist Creator'
    return (
      <Modal
        contentLabel={title}
        onRequestClose={this.props.onClose}
        isOpen
        style={modalStyles}
      >
        <div className="Form">
          <div className="Form_Header">{title}</div>
          {this._renderShortlistOptions()}
        </div>
      </Modal>
    )
  }
}
